import { LinkButton } from '@yes.technology/react-toolkit'
import EmptyStates from 'component/EmptyStates/EmptyStates'
import GenericObjectCard from 'component/GenericObjectCard'
import { useTranslation } from 'react-i18n-lite'
import { FilteredItemsProps } from '../../FilterableMap.types'
import {
  CardWrapper,
  CardsContainer,
  EmptyStatesContainer,
  FilteredObjectSkeletonDots
} from './styles'

export const PAID_STANDARD = 'paid_standard'

export type FilteredObjectsProps = {
  objects: FilteredItemsProps[]
  target?: '_self' | '_blank'
  actionColor?: string
  isLoading?: boolean
}

const FilteredObjects = ({
  objects,
  target = '_blank',
  actionColor = '#006bff',
  isLoading = false
}: FilteredObjectsProps) => {
  const { t } = useTranslation()

  return (
    <>
      {isLoading || !objects?.length ? (
        <EmptyStatesContainer $color={actionColor}>
          {!isLoading && !objects.length ? (
            <EmptyStates state='no-results-found' showComplement />
          ) : (
            <FilteredObjectSkeletonDots data-testid='skeleton-dots' />
          )}
        </EmptyStatesContainer>
      ) : (
        <CardsContainer role='list'>
          {objects.map(({ complement, des, uuid, documento }) => {
            const isPaidStandard = documento?.[0]?.des === PAID_STANDARD

            const documentButtonLabel = isPaidStandard
              ? t('filterable-map.paid-standard')
              : t('filterable-map.document-label')

            const href = isPaidStandard ? '#' : documento?.[0]?.des || ''

            return (
              <CardWrapper key={uuid} role='listitem'>
                <GenericObjectCard
                  complement={complement}
                  des={des}
                  CustomAction={
                    documento?.[0]?.des ? (
                      <LinkButton
                        variant='secondary'
                        href={href}
                        target={target}
                        rel='noopener noreferrer'
                        style={{
                          color: actionColor,
                          borderColor: actionColor
                        }}
                        disabled={isPaidStandard}
                      >
                        {documentButtonLabel}
                      </LinkButton>
                    ) : null
                  }
                />
              </CardWrapper>
            )
          })}
        </CardsContainer>
      )}
    </>
  )
}

export default FilteredObjects
